module.exports = __webpack_public_path__ + "static/media/cigarettes_01_thumb.cdfe1449.png";